<script setup lang="ts">
// A Modal preset for forms (Sierra's sheet() with fld()): a <form> whose Cancel and
// Save sit in the sheet's head, with fields laid out two wide (one on phones; give a
// field class "full" to span both). Emits `submit` (Enter in a field works too) and
// `close`. `busy` disables both buttons while a save is in flight.
import { useId } from 'vue';
import Button from './Button.vue';
import Modal from './Modal.vue';

withDefaults(defineProps<{ open: boolean; title: string; submitLabel?: string; cancelLabel?: string; busy?: boolean; wide?: boolean }>(), {
  submitLabel: 'Save',
  cancelLabel: 'Cancel',
  busy: false,
  wide: false,
});
const emit = defineEmits<{ submit: []; close: [] }>();
const id = useId();
</script>

<template>
  <Modal :open="open" :title="title" :wide="wide" @close="emit('close')">
    <form :id="`${id}-form`" class="itc-sheet-form" novalidate @submit.prevent="busy || emit('submit')">
      <div class="itc-sheet-form__fields"><slot /></div>
    </form>
    <template #actions>
      <Button variant="ghost" :disabled="busy" @click="emit('close')">{{ cancelLabel }}</Button>
      <Button variant="primary" type="submit" :form="`${id}-form`" :disabled="busy">{{ submitLabel }}</Button>
    </template>
    <template v-if="$slots.foot" #foot><slot name="foot" /></template>
  </Modal>
</template>

<style scoped>
.itc-sheet-form__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.itc-sheet-form__fields > :deep(.full) {
  grid-column: 1 / -1;
}
@media (max-width: 720px) {
  .itc-sheet-form__fields {
    grid-template-columns: 1fr;
  }
}
</style>
